import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'
import TableCell from './TableCell'
import NoData from 'components/Shared/NoData/Index'

export const StyledTableRow = styled.tr`
  height: 40px;
  ${props => props.withTopBorder && css`
    border-top: 1px solid ${colors.secondary95};
  `}
  border-bottom: 1px solid ${colors.secondary95};
`


const TableRowNoData = ({
  innerRef, hasFilterOrSearch, data, withTopBorder,
}) => {
  if (data && data.length > 0) {
    return null
  }

  return (
    <StyledTableRow ref={innerRef} id='no_data_row' withTopBorder={withTopBorder}>
      <TableCell colSpan='100%'>
        <NoData
          withIcon
          hasFilterOrSearch={hasFilterOrSearch}
        />
      </TableCell>
    </StyledTableRow>
  )
}

TableRowNoData.propTypes = {
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  hasFilterOrSearch: PropTypes.bool,
  data: PropTypes.array,
  withTopBorder: PropTypes.bool,
}

export default TableRowNoData
